const IS_DEV = import.meta.env.VITE_IS_PROD !== 'true'
const IS_PROD = import.meta.env.VITE_IS_PROD === 'true'

// NOTE:
// Разрешаем конфигурировать API как абсолютными URL, так и относительными путями.
// Если VITE_API_DOMAIN не задан — по умолчанию используем текущий origin (удобно для локальной разработки).
const resolveOrigin = (): string => {
  if (typeof window !== 'undefined' && window.location?.origin) return window.location.origin
  return ''
}

const API_DOMAIN = (import.meta.env.VITE_API_DOMAIN as string | undefined)?.trim() || resolveOrigin()
const TRUSTED_API_DOMAIN = (import.meta.env.VITE_API_DOMAIN as string | undefined)?.trim() || ''
const API_URL = (import.meta.env.VITE_API_URL as string | undefined)?.trim()
  || `${API_DOMAIN}/office-data/request`
const TOPUP_CALLBACK_BASE_URL = (
  (import.meta.env.VITE_TOPUP_CALLBACK_BASE_URL as string | undefined)?.trim()
  || TRUSTED_API_DOMAIN
)
const CORDOVA_RETURN_BASE_URL = (
  (import.meta.env.VITE_CORDOVA_RETURN_BASE_URL as string | undefined)?.trim()
  || ''
)
const normalizeHostFromEnv = (value: string) => {
  const normalizedValue = value.trim().toLowerCase()
  if (!normalizedValue) return null

  try {
    const normalizedUrl = new URL(
      normalizedValue.includes('://')
        ? normalizedValue
        : `https://${normalizedValue}`
    )
    return normalizedUrl.hostname.toLowerCase() || null
  } catch {
    return null
  }
}
const TOPUP_CALLBACK_ALLOWED_ROOTS = Array.from(new Set(
  (
    (import.meta.env.VITE_TOPUP_CALLBACK_ALLOWED_ROOTS as string | undefined)
      ?.split(',')
      .map((item) => normalizeHostFromEnv(item))
      .filter((item): item is string => !!item)
  ) || []
))

const YANDEX_METRIKA_COUNTER_ID = (
  // prefer Vite-prefixed env name
  (import.meta.env.VITE_YANDEX_METRIKA_COUNTER_ID as string | undefined)
  // backward compatibility
  || (import.meta.env.YANDEX_METRIKA_COUNTER_ID as string | undefined)
  || ''
)
// Optional: URL to JSON describing latest Cordova (APK) version and download link.
// If not provided, we'll try `${API_DOMAIN}/data/cordova-update.json`.
const CORDOVA_UPDATE_INFO_URL = (import.meta.env.VITE_CORDOVA_UPDATE_INFO_URL as string | undefined)
  || `${API_DOMAIN}/data/cordova-update.json`

export const envs = {
  IS_DEV,
  IS_PROD,
  API_DOMAIN,
  TRUSTED_API_DOMAIN,
  TOPUP_CALLBACK_BASE_URL,
  CORDOVA_RETURN_BASE_URL,
  TOPUP_CALLBACK_ALLOWED_ROOTS,
  API_URL,
  YANDEX_METRIKA_COUNTER_ID,
  CORDOVA_UPDATE_INFO_URL,
}
